import { render, staticRenderFns } from "./GeneratorOrderPageSearchItemsDetail.vue?vue&type=template&id=68ef3357&scoped=true"
import script from "./GeneratorOrderPageSearchItemsDetail.vue?vue&type=script&lang=js"
export * from "./GeneratorOrderPageSearchItemsDetail.vue?vue&type=script&lang=js"
import style0 from "./GeneratorOrderPageSearchItemsDetail.vue?vue&type=style&index=0&id=68ef3357&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef3357",
  null
  
)

export default component.exports